import type { FC } from 'react';
import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import useCurrentTasksFormStore from '../../hooks/useCurrentTasksFormStore';
import type { SelectChangeEvent } from '@mui/material';
import { ConditionOperator } from '../RuleEditComponents';
import type { FormConditionVariantProps } from '../../types';

export const TaskConditionOperator: FC<Omit<FormConditionVariantProps, 'field'> & { isSingleCondition?: boolean }> =
  observer(({ indexCondition, indexTask, isSingleCondition, indexVariant }) => {
    const isVariant = typeof indexVariant === 'number';

    const tasksFormStore = useCurrentTasksFormStore();
    const handleChangeOperator = useCallback(
      (e: SelectChangeEvent) => {
        if (isVariant) {
          tasksFormStore.setVariantOnTaskConditionMetric(
            indexTask,
            indexVariant,
            indexCondition,
            'operator',
            e.target.value
          );
        } else {
          tasksFormStore.setConditionMetric(indexTask, indexCondition, 'operator', e.target.value);
        }
      },
      [isVariant, tasksFormStore, indexTask, indexVariant, indexCondition]
    );

    const value = isVariant
      ? tasksFormStore.getVariantOnTaskCondition(indexTask, indexVariant, indexCondition)?.operator
      : tasksFormStore.getConditionMetric(indexTask, indexCondition)?.operator;

    return <ConditionOperator isSingleCondition={isSingleCondition} value={value} onChange={handleChangeOperator} />;
  });

export default TaskConditionOperator;
